import { c as _c } from "react/compiler-runtime";
import { Stack, Tooltip, Typography } from '@mui/material';
import { ResourceType, type InventoryResource } from '@repo/api-gw-sdk';
import type { Row, Table } from '@tanstack/react-table';
import classNames from 'classnames';
import { useRouter } from 'next/navigation';
import { ThreatIssueIcon } from '@/components/security/threatIcons';
import { CellActionsWrapper } from '@/components/table/cellActionsWrapper';
import { hasSecurityIssue } from '../../security/securityUtils';
interface ResourceNameCellProps {
  row: Row<InventoryResource>;
  table: Table<InventoryResource>;
}
export const ResourceNameCell = t0 => {
  const $ = _c(7);
  const {
    row,
    table
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router || $[1] !== row || $[2] !== table) {
    t1 = () => {
      if (row.original.resourceType === ResourceType.GoogleWorkspaceResource) {
        router.push(`/explorer/${encodeURIComponent(row.original.id)}`);
        return;
      }
      if (row.getIsSelected()) {
        table.resetRowSelection(true);
      } else {
        table.setRowSelection({
          [row.id]: true
        });
      }
    };
    $[0] = router;
    $[1] = row;
    $[2] = table;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClick = t1;
  let t2;
  if ($[4] !== handleClick || $[5] !== row) {
    t2 = <BasicResourceNameCell row={row} onClick={handleClick} />;
    $[4] = handleClick;
    $[5] = row;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export const BasicResourceNameCell = t0 => {
  const $ = _c(6);
  const {
    row,
    onClick
  } = t0;
  if (!row.original.resourceName) {
    return null;
  }
  let t1;
  if ($[0] !== onClick || $[1] !== row.original) {
    t1 = hasSecurityIssue(row.original) ? <Stack direction="row" sx={{
      alignItems: "center",
      gap: "8px"
    }}><Tooltip title="Threat findings in the latest snapshot."><Stack><ThreatIssueIcon /></Stack></Tooltip><Typography data-testid="resource-name-cell" className={classNames({
        "underline hover:cursor-pointer [&:hover]:text-(--mui-palette-error-light)!": onClick
      }, "text-(--mui-palette-error-main)!")} onClick={onClick}>{row.original.resourceName}</Typography></Stack> : <Typography data-testid="resource-name-cell" className={onClick ? "underline hover:cursor-pointer hover:text-(--mui-palette-text-secondary)" : ""} onClick={onClick} sx={{
      lineHeight: "24px",
      position: "relative"
    }}>{row.original.resourceName}</Typography>;
    $[0] = onClick;
    $[1] = row.original;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== row.original.resourceName || $[4] !== t1) {
    t2 = <CellActionsWrapper textToCopy={row.original.resourceName}>{t1}</CellActionsWrapper>;
    $[3] = row.original.resourceName;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};